import { AccountsTable } from './AccountsTable';

export const AccountsPage = () => (
    <div className={'padding-25'}>
        <AccountsTable />
    </div>
);
